<template>
    <div class='camera-manager'>
        <div class="body">
            <div class="input-box">
                <el-input placeholder="请输入点位名称" class="w250 mr20 seekIpt" v-model="searchValue" @keyup.enter.native="search()">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search()"></i>
                </el-input>
                <el-select class="ml20" v-model="status" @change="search()" placeholder="绑定状态" clearable>
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <!-- 
                    <el-select class="ml20" v-model="cameraType" @change="search()" placeholder="摄像头类型" clearable>
                        <el-option v-for="item in cameraTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                    </el-select> 
                -->
            </div>
            <div class="options-box">
                <el-button :disabled="cameraList.length === 0" @click="setStatusMult()">批量绑定</el-button>
            </div>
            <div class="table-box" ref="cameraManagerTable">
                <el-table v-loading="tableLoading" element-loading-text="数据正在努力加载中" :border="true" :resizable="true" :data="tableData" class="table-div" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" align="center" width="50" :selectable="selectable"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="name" align="center" min-width="120" empty-text="-" label="点位名称">
                        <template slot-scope="scope">
                            <span v-if="scope.row.name"> {{ scope.row.name }} </span>
                            <span v-else> - </span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="videoUrl" align="center" min-width="120" empty-text="-" label="直播流地址">
                        <template slot-scope="scope">
                            <span v-if="scope.row.videoUrl"> {{ scope.row.videoUrl }} </span>
                            <span v-else> - </span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="coverUrl" align="center" min-width="120" empty-text="-" label="封面">
                        <template slot-scope="scope">
                            <el-image style=" height: 48px" v-if="scope.row.coverUrl" :src="scope.row.coverUrl" fit="contain" :preview-src-list="[scope.row.coverUrl]"></el-image>
                            <span v-else> - </span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="bindStatusStr" align="center" empty-text="-" min-width="60" label="绑定状态" />
                    <el-table-column show-overflow-tooltip prop="subCanteenName" align="center" min-width="120" label="所属食堂">
                        <template slot-scope="scope">
                            <span v-if="scope.row.subCanteenName"> {{ scope.row.subCanteenName }} </span>
                            <span v-else> - </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="120" align="center" fixed="right">
                        <template slot-scope="scope">
                            <a href="javascript:;" v-if="scope.row.bindStatus === 0" class="operate-a" @click="setStatus([scope.row.id], 1)">绑定</a>
                            <a href="javascript:;" v-if="scope.row.bindStatus === 1" class="operate-a" @click="setStatus([scope.row.id], 0)">解绑</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination class="floatR" v-bind="pagination" @size-change="pageSizeChange" @current-change="pageCurrentChange"> </el-pagination>
            </div>
        </div>

        <!-- 弹窗 -->
        <el-dialog title="摄像头绑定" :visible.sync="dialog.bindCamera" :close-on-click-modal="false" width="500px">
            <el-form :model="bindForm" :rules="bindFormRules" ref="bindForm">
                <el-form-item class="select-bind-camera" prop="selectRoomId">
                    <el-select v-model="bindForm.selectRoomId" placeholder="请选择需绑定的食堂">
                        <el-option v-for="item in roomList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog.bindCamera = false">取 消</el-button>
                <el-button type="primary" @click="bindRoom()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as api from '../../../api/camera';

export default {
    data() {
        return {
            tableLoading: false,
            tableData: [],
            searchValue: '',
            status: '',
            statusList: [
                { label: '已绑定', value: 1 },
                { label: '未绑定', value: 0 },
            ],
            cameraType: '',
            cameraTypeList: [],
            pagination: {
                layout: "total, sizes, prev, pager, next, jumper",
                total: 0,
                pageSize: 10,
                pageSizes: [10, 20, 30, 40, 50],
                currentPage: 1,
                background: true,
            },
            bindForm: {
                selectRoomId: '', // 选中的绑定 子食堂id
            },
            roomList: [ // 食堂列表

            ],
            dialog: {
                bindCamera: false
            },
            cameraList: [], // 需要绑定的摄像头id（多选操作）
            camera: [], // 需要绑定的摄像头id （单个绑定）
            isMult: false, // 是否是多选操作 （true 取 cameraList， false 取 camera）
            bindFormRules: {
                selectRoomId: [
                    { required: true, message: '请选择所需绑定食堂', trigger: 'blur' },
                ]
            }
        };
    },
    mounted() {
        // api.getCameraType().then(data => {
        //     this.cameraTypeList = data.data;
        // })
        api.getSubList().then(data => {
            this.roomList = data.data;
            // 移除 未绑定
            if (this.roomList && this.roomList[0].id === 'UNBOUN') {
                this.roomList.splice(0, 1);
            }
        })
        this.search();
    },
    methods: {
        search(currentPage = 1) {
            this.tableLoading = true;
            let data = {
                bindStatus: this.status,
                keyWord: this.searchValue,
                pageNum: currentPage,
                pageSize: this.pagination.pageSize,
                type: this.cameraType,
            }
            this.pagination.currentPage = currentPage;

            api.getCameraList(data)
                .then(data => {
                    if (data.code === 200) {
                        data = data.data;
                        this.tableData = data.records;
                        this.pagination.total = data.total;
                    }
                })
                .finally(data => {
                    this.tableLoading = false;
                })
        },
        handleSelectionChange(selection) {
            this.cameraList = selection.map(item => item.id);

        },
        pageSizeChange(currentPageSize) {
            this.pagination.pageSize = currentPageSize;
            this.search();

        },
        pageCurrentChange(currentPage) {
            this.pagination.currentPage = currentPage;
            this.search(currentPage);
        },
        selectable(row, index) {
            if (row.bindStatus === 1) {
                return false;
            }
            return true;
        },
        setStatusMult() {
            this.isMult = true;
            this.dialog.bindCamera = true;
        },
        setStatus(cameraIdList, bindStatus) {
            this.isMult = false;
            this.camera = cameraIdList;

            if (bindStatus === 1) {
                this.dialog.bindCamera = true;
            }
            else if (bindStatus === 0) {
                this.bind(bindStatus);
            }
        },
        bindRoom() {
            this.$refs['bindForm'].validate((valid) => {
                if (valid) {
                    this.bind(1);
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        bind(bindStatus) {
            this.tableLoading = true;
            let data = {
                bindStatus: bindStatus,
                cameraList: this.isMult ? this.cameraList : this.camera,
                subCanteen: bindStatus === 1 ? this.bindForm.selectRoomId : 'noEmpty',
            }
            api.setBind(data)
                .then(data => {
                    if (data.code === 200) {
                        bindStatus === 1 ? this.$message.success('绑定成功') : this.$message.success('解绑成功');
                    }
                })
                .finally(data => {
                    this.search();
                    this.dialog.bindCamera = false;
                })
        }
    }
};
</script>

<style lang='scss' scope>
.camera-manager {
    padding: 20px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    > .body {
        position: relative;
        padding: 20px 30px;
        width: 100%;
        min-height: 100%;
        background-color: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        .input-box {
            padding-top: 20px;
        }
        .options-box {
            margin-top: 20px;
            height: 40px;
        }
        .table-box {
            margin-top: 20px;
            padding-bottom: 100px;
        }
        .page-box {
            position: absolute;
            bottom: 50px;
            right: 30px;
        }
    }
    .select-bind-camera {
        display: block;
        margin: 50px auto;
        width: 300px;
        .el-select {
            width: 300px;
        }
    }
}
</style>